var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4Timeplaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2009_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.505 172.502C75.1822 183.309 5 213.922 5 249.997C5 286.071 75.1822 316.685 172.505 327.492C169.8 303.132 168.334 277.074 168.334 249.997C168.334 222.914 169.8 196.854 172.505 172.502Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.995 5C114.691 5 5.00879 114.69 5.00879 250.009C5.00879 204.904 114.696 168.344 249.995 168.344C277.077 168.344 303.137 169.809 327.488 172.515C316.681 75.1823 286.069 5 249.995 5Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.483 327.48C424.813 316.672 494.988 286.06 494.988 249.985C494.988 213.91 424.811 183.297 327.483 172.49C330.188 196.849 331.654 222.901 331.654 249.985C331.654 277.07 330.188 303.128 327.483 327.48Z",
    fill: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.996 495C385.307 495 495 385.31 495 249.991C495 295.096 385.313 331.656 249.996 331.656C222.913 331.656 196.861 330.191 172.51 327.485C183.31 424.81 213.922 495 249.996 495Z",
    fill: "#B7B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2009_383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Timeplaceholder);
export default __webpack_public_path__ + "static/media/4timeplaceholder.5af2f1532d10d6f18c9015387f3fbe46.svg";
export { ForwardRef as ReactComponent };